export default "__VITE_ASSET__ULIaeLXj__"